import { Email } from '@mui/icons-material';
import dayjs from 'dayjs';
import { useCallback } from 'react';
import {
  Button,
  useListContext,
  useNotify,
  useRecordContext,
  useRefresh,
  useResourceContext,
  useUnselectAll,
  useUpdateMany
} from 'react-admin';

function MarkAsReadedButton(): JSX.Element {
  const refresh = useRefresh();
  const notify = useNotify();
  const resource = useResourceContext() as string;
  const unselectAll = useUnselectAll(resource);
  const { selectedIds, data: tableRows } = useListContext();
  const record = useRecordContext();
  const rows = selectedIds.map((id) => tableRows.find((d) => d.id === id));
  const [updateMany, { isLoading }] = useUpdateMany(
    resource,
    {
      ids: selectedIds.length > 0 ? selectedIds : [record?.id],
      data: { readed: dayjs().toISOString() },
      // @ts-ignore
      rows
    },
    {
      onSuccess: () => {
        refresh();
        notify('resources.notifications.messages.readed.done');
        unselectAll();
      },
      onError: () => notify('ra.notification.readed_error', { type: 'warning' }),

      onFailure: () => notify('ra.notification.readed_error', { type: 'warning' })
    }
  );
  const handleUpdateMany = useCallback(() => {
    updateMany();
  }, [updateMany]);

  return (
    <Button
      label="ra.notification.mark_as_readed"
      disabled={isLoading || record?.readed !== null}
      onClick={handleUpdateMany}
    >
      <Email />
    </Button>
  );
}

export { MarkAsReadedButton };
